import { ILoginResponse } from "app/services/default";
import { IAsyncState } from "app/core/redux";

// Action types
export enum AuthActionTypes {
    GET_LOGIN_REQUEST = "@user/GET_LOGIN_REQUEST",
    GET_LOGIN_SUCCESS = "@user/GET_LOGIN_SUCCESS",
    GET_LOGIN_FAILTURE = "@user/GET_LOGIN_FAILTURE"
}

// Reducer state
export interface IAuthState {
    isAuthenticated: boolean;
    login: IAsyncState<ILoginResponse>;
}
